<!--<mat-form-field style="width:100%">
	<input matInput #search autocomplete="off" placeholder="SEARCH INVENTORY" (input)="productSearch()">
</mat-form-field>-->


<form [formGroup]="productsForm" enctype="multipart/form-data" (ngSubmit)="submit()" autocomplete="off">
	<input type="hidden" autocomplete="off">
		<div class="container"
		  fxLayout="row"
		  fxLayoutAlign="start center"
		  fxLayoutGap="10px"
		  style="padding:0px 10px 0px 10px;">
		<div class="item item-1" fxFlex="1 1 150px">
			<mat-form-field floatLabel="always">
				<mat-select #formRow #statusSelect placeholder="SHOW" formControlName="showStock" (selectionChange)="filterProductStock()">
					<mat-option value="all">ALL</mat-option>
					<mat-option value="stock">IN-STOCK</mat-option>
					<mat-option value="return">RETURNED</mat-option>
					<mat-option value="rx">RX</mat-option>
					<mat-option value="sun">SUN</mat-option>
					<mat-option value="catalog">CURRENT CATALOG</mat-option>
					<mat-option value="discontinued">POSSIBLY DISCONTINUED</mat-option>
					<mat-option value="special">SPECIAL ORDER</mat-option>
					<mat-option value="manual">MANUALLY ADDED</mat-option>
					<mat-option value="parts">PARTS</mat-option>
				</mat-select>
      </mat-form-field>

			<!-- <mat-radio-group formControlName="showStock2" (change)="filterProductStock()">
				<mat-radio-button value="all">SHOW ALL</mat-radio-button> &nbsp;
				<mat-radio-button value="stock">SHOW IN-STOCK</mat-radio-button>
			</mat-radio-group> -->
		</div>
		<div fxFlex="1 1 250px">
			<mat-form-field floatLabel="never" style="width:100% !important;">
	      <input matInput placeholder="SEARCH" type="text" formControlName="search" autocomplete="off" (keyup.enter)="searchControlEnter($event)">
	      <!-- <input matInput placeholder="SEARCH" type="text" formControlName="search" (keyup)="filterProducts($event.target.value)" autocomplete="off"> -->
	    </mat-form-field>
	  </div>
	  <div class="inventory-action-buttons" fxFlex="0 0 auto" fxLayout="row" fxLayoutGap="8px">
			<button mat-raised-button type="button" (click)="showEverything()">SHOW EVERYTHING (IN STOCK)</button>
			<button mat-raised-button type="button" (click)="showAllFrames()">ALL FRAMES</button>
			<button
				mat-raised-button
				color="primary"
				type="button"
				*ngIf="_vendor?._id && !borrowingView"
				(click)="openCatalogImport()"
			>
				IMPORT CATALOG
			</button>
			<span class="catalog-sync-meta" *ngIf="_vendor?.lastCatalogImportAt && !borrowingView">
				Last catalog {{ _vendor.lastCatalogImportAt | date:'M/d/yy' }}
				<span *ngIf="_vendor?.nextCatalogDueAt">
					· due {{ _vendor.nextCatalogDueAt | date:'M/d/yy' }}
				</span>
			</span>
	  </div>

	  <div fxFlex="1 1 auto">
		  <h3 style="text-align:center;" *ngIf="dataLoading && progressiveRenderTotal">{{ progressiveRenderCount }} / {{ progressiveRenderTotal }}</h3>
		  <h3 style="text-align:center;" *ngIf="dataLoading && !progressiveRenderTotal">LOADING INVENTORY</h3>
		  <mat-progress-bar mode="indeterminate" *ngIf="dataLoading"></mat-progress-bar>
		</div>
	</div>

	<div class="catalog-alert" *ngFor="let alert of catalogAlerts" [class.overdue]="alert.alert === 'overdue'">
		<span>
			{{ alert.name }} catalog is {{ alert.alert === 'overdue' ? 'OVERDUE' : 'DUE' }}
			<span *ngIf="alert.nextCatalogDueAt"> ({{ alert.nextCatalogDueAt | date:'M/d/yy' }})</span>
		</span>
		<button mat-button type="button" (click)="openCatalogImport(alert)">IMPORT CATALOG</button>
		<button mat-button type="button" (click)="dismissCatalogAlert(alert)">DISMISS</button>
	</div>

  <mat-table #table [dataSource]="dataSource" matSort multiTemplateDataRows [trackBy]="trackByProductId">
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 50px" style="padding-left:0px !important;">
        <mat-checkbox (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=index;" fxFlex="0 0 50px">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? toggleSelect(vendor,row) : null"
          [checked]="isRowSelected(row)"
          [aria-label]="checkboxLabel(row.formGroup,i)">
        </mat-checkbox>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 100px" class="alignLeftCellFooter" style="padding-left:0px !important;"> TOTAL </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="images">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 150px">
      	<ng-container *ngIf="selection.hasValue()">
					<app-inventory-menu [selection]="selection" [productsForm]="productsForm" (borrowing)="borrowMultipleProducts($event)" (updateProducts)="updateProducts()"></app-inventory-menu>
				</ng-container>
      	<ng-container *ngIf="!selection.hasValue()">
          IMAGE
				</ng-container>
			</mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 150px">
        <app-images
          *ngIf="isEditing(row); else inventoryImagePreview"
          [images]="rowValue(row).images"
          [urls]="imageUrls"
          type="product"
          (imagesChange)="updateImages($event, row)"
          [edit]="true"
          [delete]="true"
          [upload]="true"
          [autoCrop]="true"
          [active]="true"
          [productId]="rowValue(row)._id"
          (click)="clickImage($event,row,i)">
        </app-images>
        <ng-template #inventoryImagePreview>
          <img
            *ngIf="getPreviewImageUrl(row) as previewUrl"
            [src]="previewUrl"
            alt=""
            class="inventory-image-preview"
            (click)="clickImage($event, row, i)" />
        </ng-template>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="1 0 85px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="vendor" *ngIf="!vendor">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 10%"> VENDOR </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex; let even=even; let odd=odd;" fxFlex="1 0 10%">
      	<button *ngIf="getVendorRef(rowValue(row)) as vendorRef" mat-button (click)="clickField($event, row, i)" [routerLink]="['/admin/vendors', vendorRef._id]" style="width:90%;">{{vendorRef.name}}</button>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="1 0 10%"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="model">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 10%"> MODEL </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex; let even=even; let odd=odd;" fxFlex="1 0 10%">
      	<span *ngIf="!isEditing(row) || showParts">
					{{rowValue(row).model}}
					<span class="catalog-status" *ngIf="catalogStatusLabel(rowValue(row))">
						· {{ catalogStatusLabel(rowValue(row)) }}
					</span>
					<span class="catalog-sku" *ngIf="rowValue(row).vendorSku || rowValue(row).colorCode">
						<br>
						{{ rowValue(row).vendorSku }}
						<span *ngIf="rowValue(row).colorCode"> · {{ rowValue(row).colorCode }}</span>
					</span>
				</span>
      	<app-autocomplete-vendor-products
	  			[productForm]="row.formGroup"
	    		[vendor]="_vendor"
	  			placeholder="MODEL"
	  			*ngIf="isEditing(row) && !showParts"
	  			[(fieldOpen)]="fieldOpen"
	  			displayField="model"
					style="width:90%"
	  			>
				</app-autocomplete-vendor-products>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="1 0 10%"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="color">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 75px"> COLOR </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="1 0 75px">
      	<span *ngIf="!isEditing(row) || showParts">{{rowValue(row).color}}</span>
      	<app-autocomplete-vendor-products
	  			[productForm]="row.formGroup"
	    		[vendor]="_vendor"
	  			placeholder="COLOR"
	  			*ngIf="isEditing(row) && !showParts"
	  			[(fieldOpen)]="fieldOpen"
	  			displayField="color"
					style="width:90%"
	  			>
				</app-autocomplete-vendor-products>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="1 0 2.5%"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="size">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 40px"> SIZE </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 40px">
      	<span *ngIf="!isEditing(row) || showParts">{{rowValue(row).size}}</span>
      	<app-autocomplete-vendor-products
	  			[productForm]="row.formGroup"
	    		[vendor]="_vendor"
	  			placeholder="SIZE"
	  			*ngIf="isEditing(row) && !showParts"
	  			[(fieldOpen)]="fieldOpen"
	  			displayField="size"
					style="width:90%"
	  			>
				</app-autocomplete-vendor-products>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 75px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 65px"> STATUS </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 65px" style="padding-left:0px;min-width:calc(100%-32px);" [ngClass]="getStatusCellClass(row)" [ngStyle]="getStatusCellStyle(row)">

      	<mat-form-field *ngIf="isEditing(row) && !showParts" floatLabel="never" [formGroup]="row.formGroup">
					<mat-select #formRow #statusSelect placeholder="STATUS" [formControl]="row.formGroup.controls.status" (selectionChange)="changeProductStatus($event,row.formGroup,i)" appClickField [(fieldOpen)]="fieldOpen">
						<mat-option value="green" class="green"></mat-option>
						<mat-option value="yellow" class="yellow"></mat-option>
						<mat-option value="red" class="red"></mat-option>
						<mat-option value="purple" class="purple"></mat-option>
						<mat-option value="white" class="white"></mat-option>
						<mat-option value="black" class="black"></mat-option>
					</mat-select>
        </mat-form-field>


<!-- 				<mat-form-field *ngIf="productId==product.value._id" floatLabel="never" style="min-width:calc(100%-32px);" class="statusSelect" style="min-width:65px;">

					<mat-select #statusSelect #formRow placeholder="" [formControl]="product.controls.status" panelClass="status-select-panel"  (click)="clickField($event, product.value, i);$event.stopPropagation();" (selectionChange)="changeProductType($event,product,i)">
						<mat-option value="green" class="green"></mat-option>
						<mat-option value="yellow" class="yellow"></mat-option>
						<mat-option value="red" class="red"></mat-option>
						<mat-option value="white" class="white"></mat-option>
						<mat-option value="black" class="black"></mat-option>
					</mat-select>
        </mat-form-field> -->


<!--
      	<mat-form-field *ngIf="clickedStatus==i+paginator.pageSize*paginator.pageIndex" floatLabel="never" style="width:20px;">

					<mat-select #statusSelect #formRow placeholder="" formControlName="status" (click)="clickRush($event,product,i+paginator.pageSize*paginator.pageIndex)" (selectionChange)="changeStatus($event,product,i+paginator.pageSize*paginator.pageIndex)" class="statusSelect" panelClass="status-select-panel" disableRipple style="width:20px;">
						<mat-option value="green" class="green"><span style="width:20px;">G</span></mat-option>
						<mat-option value="yellow" class="yellow"><span style="width:20px;">Y</span></mat-option>
						<mat-option value="red" class="red"><span style="width:20px;"></span>R</mat-option>
						<mat-option value="red" class="white"><span style="width:20px;"></span>x</mat-option>
					</mat-select>
        </mat-form-field>
        -->

      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 65px"> </mat-footer-cell>
    </ng-container>
<!--
    <ng-container matColumnDef="commission">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 2.5%"> COMM. </mat-header-cell>
      <mat-cell *matCellDef="let product; let i=dataIndex;" [formGroupName]="i" fxFlex="1 0 2.5%">
      	<span *ngIf="productId!=product._id">{{product.commission}}</span>
				<mat-form-field *ngIf="productId==product._id" floatLabel="never">
					<mat-select #formRow placeholder="COMM." formControlName="commission" (click)="clickCommission($event,product,i)">
						<mat-option *ngFor="let commissionOption of commissionOptions" [value]="commissionOption.value">
							{{commissionOption.viewValue}}
						</mat-option>
					</mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>
-->

    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px"> TYPE </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 50px">
      	<span *ngIf="(!isEditing(row) && rowValue(row)._id!='NEW') || showParts">{{rowValue(row).type}}</span>
				<mat-form-field *ngIf="isEditing(row) && !showParts" floatLabel="never" [formGroup]="row.formGroup">
					<mat-select #formRow placeholder="TYPE" [formControl]="row.formGroup.controls.type" (click)="clickField($event,row,i);$event.stopPropagation();" (selectionChange)="changeProductType(row.formGroup)">
						<mat-option *ngFor="let typeOption of typeOptions" [value]="typeOption.value">
							{{typeOption.viewValue}}
						</mat-option>
					</mat-select>
        </mat-form-field>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 50px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="cost">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 60px"> COST </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 60px">
      	<span *ngIf="!isEditing(row) || !authorized || showParts">{{ rowValue(row).cost | currency }}</span>
				<mat-form-field *ngIf="isEditing(row) && authorized && !showParts" floatLabel="never" [formGroup]="row.formGroup">
          <input #formRow matInput placeholder="COST" type="text" [formControl]="row.formGroup.controls.cost" (keyup)="changeCost(row.formGroup)" appClickField [(fieldOpen)]="fieldOpen">
        </mat-form-field>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 75px"> {{ getTotalCost() | currency }} </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="priceLink">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 35px">  </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 35px">
        <mat-icon (click)="togglePriceLinkForRow($event,row,i)" *ngIf="isEditing(row) && rowValue(row).pricingFormula!='c'">link_outline</mat-icon>
        <mat-icon (click)="togglePriceLinkForRow($event,row,i)" *ngIf="isEditing(row) && rowValue(row).pricingFormula=='c'" color="warn">link_off_outline</mat-icon>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 35px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="retail">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 60px"> RETAIL </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 60px">
      	<span *ngIf="!isEditing(row) || !authorized || showParts">{{ rowValue(row).retail | currency }}</span>
				<mat-form-field *ngIf="isEditing(row) && authorized && !showParts" floatLabel="never" [formGroup]="row.formGroup">
          <input #formRow matInput placeholder="RETAIL" type="text" [formControl]="row.formGroup.controls.retail" (keyup)="changeRetail(row.formGroup)" appClickField [(fieldOpen)]="fieldOpen">
        </mat-form-field>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 75px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="store">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 10%"> STORE </mat-header-cell>
      <mat-cell *matCellDef="let product; let i=dataIndex;" fxFlex="0 0 10%" [formGroupName]="i">
      	<span *ngIf="(productId!=product.value._id && product.value.store) || showParts">{{product.value.store.storeName}}</span>
        <mat-form-field *ngIf="productId==product.value._id && !showParts" floatLabel="never">
					<mat-select #formRow placeholder="STORE" formControlName="store" (click)="clickField($event,product,index);$event.stopPropagation();">
						<mat-option *ngFor="let storeOption of storeOptions" [value]="storeOption">
							{{storeOption.storeName}}
						</mat-option>
					</mat-select>
        </mat-form-field>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 10%"> </mat-footer-cell>
    </ng-container>
<!--
	  <ng-container matColumnDef="store">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 5%"> STORE </mat-header-cell>
      <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 0 5%" [formGroupName]="i">
				<span *ngIf="orderId!=order.value._id"> {{ order.value.products[0].store.storeName }} </span>
      	<ng-container formGroupName="products">
		    	<ng-container [formGroupName]="0">
						<mat-form-field *ngIf="orderId==order.value._id" style="width:90%" floatLabel="never">
		          <mat-select placeholder="STORE" formControlName="store" (click)="clickField(order, orderIndex);$event.stopPropagation();">
		            <mat-option *ngFor="let storeOption of storeOptions" [value]="storeOption">{{storeOption.storeName}}</mat-option>
		          </mat-select>
		        </mat-form-field>
		      </ng-container>
		    </ng-container>
      </mat-cell>
    </ng-container> -->

    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px"> QTY. </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 50px">
      	<span *ngIf="!isEditing(row) || showParts">{{rowValue(row).quantity}}</span>
				<mat-form-field *ngIf="isEditing(row) && !showParts" floatLabel="never" [formGroup]="row.formGroup">
          <input #formRow matInput placeholder="QTY." type="text" [formControl]="row.formGroup.controls.quantity" appClickField [(fieldOpen)]="fieldOpen">
        </mat-form-field>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 65px"> {{ getTotalQty() }} </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="orderDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 10%"> ORDER DATE </mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 10%">
      	<span>{{ rowValue(row).orderDate | date:'M/d/yyyy': 'GMT' }}</span>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 10%"> </mat-footer-cell>
    </ng-container>
<!--
    <ng-container matColumnDef="backordered">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px" style="justify-content:center;"> B.O. </mat-header-cell>
      <mat-cell *matCellDef="let product; let i=dataIndex;" [formGroupName]="i" fxFlex="0 0 50px">
      	<mat-slide-toggle formControlName="backordered" (click)="clickRush($event,product,i)" (change)="changeRush($event,product,i)" color="primary"></mat-slide-toggle>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="wishlist">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px" style="justify-content:center;"> WISH LIST </mat-header-cell>
      <mat-cell *matCellDef="let product; let i=dataIndex;" [formGroupName]="i" fxFlex="0 0 50px">
      	<mat-slide-toggle formControlName="wishlist" (click)="clickRush($event,product,i)" (change)="changeRush($event,product,i)" color="primary"></mat-slide-toggle>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sold">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px" style="justify-content:center;"> SOLD </mat-header-cell>
      <mat-cell *matCellDef="let product; let i=dataIndex;" [formGroupName]="i" fxFlex="0 0 50px">
      	<span *ngIf="productId!=product._id">{{product.sold}}</span>
				<mat-form-field *ngIf="productId==product._id" floatLabel="never">
          <input #formRow matInput placeholder="SOLD" type="text" formControlName="sold">
        </mat-form-field>
      </mat-cell>
    </ng-container>
-->

		<ng-container matColumnDef="borrow">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 120px"><ng-container *ngIf="borrowingView">BORROW</ng-container></mat-header-cell>
	    <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 120px">
      	<ng-container *ngIf="_vendor.borrowingStores?.includes(currentStore._id); else notBorrowingBlock">
	      	<ng-container *ngFor="let borrowing of rowValue(row).borrowing">
	      		{{ rowValue(row).store.storeName }}
	      	</ng-container>
      	</ng-container>
      	<ng-template #notBorrowingBlock>
					<ng-container *ngIf="!borrowingView || rowValue(row).quantity - (allRentingQtyByProduct[rowValue(row)._id] ?? 0) - getBorrowingSum(rowValue(row).borrowing || []) === 0">
						<ng-container *ngFor="let borrowing of rowValue(row).borrowing">
							{{ storeService.getStoreObjectFromId(borrowing.store)?.storeName }}
							({{borrowing.quantity}})
						</ng-container>
					</ng-container>

					<mat-checkbox *ngIf="!isEditing(row) && borrowingView && rowValue(row).quantity - (allRentingQtyByProduct[rowValue(row)._id] ?? 0) - getBorrowingSum(rowValue(row).borrowing || []) > 0"
						(click)="$event.stopPropagation()"
						(change)="$event ? toggleSelectBorrow(vendor,row) : null"
						[checked]="isRowBorrowSelected(row)">
					</mat-checkbox>
      	</ng-template>
	    </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 100px"> </mat-footer-cell>
		</ng-container>

		<ng-container matColumnDef="rent">
			<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 120px">
				<ng-container *ngIf="user.role === 'RENTAL'; else rentHeaderBlock">BORROW</ng-container>
				<ng-template #rentHeaderBlock>RENT</ng-template>
			</mat-header-cell>
			<mat-cell *matCellDef="let row; let i = dataIndex;" fxFlex="0 0 120px">
      	<mat-checkbox *ngIf="!_vendor.borrowingStores?.includes(currentStore._id) && !isEditing(row) && user.role !== 'RENTAL' && rentingView && rentingUser && rowValue(row).quantity - (allRentingQtyByProduct[rowValue(row)._id] ?? 0) - getBorrowingSum(rowValue(row).borrowing || []) > 0"
      		(click)="$event.stopPropagation()"
          (change)="onSelectRenting($event, rowValue(row)._id, getVendorRef(rowValue(row))?._id)"
          [checked]="getUpdatedRenting(rowValue(row)._id)?.checked">
				</mat-checkbox>
				<ng-container *ngIf="(user.role === 'RENTAL' || (rentingUser && (!rentingView || rowValue(row).quantity - (allRentingQtyByProduct[rowValue(row)._id] ?? 0) - getBorrowingSum(rowValue(row).borrowing || []) === 0))) && getRenting(rowValue(row)._id)">
					{{ getRenting(rowValue(row)._id).qty }}
				</ng-container>
				<ng-container *ngIf="!rentingUser && user.role !== 'RENTAL' && rowValue(row).quantity > 0">
					<div fxLayout="column">
						<ng-container *ngFor="let rentsObj of rentingList | keyvalue">
							<ng-container *ngFor="let rent of rentsObj.value">
								<span *ngIf="rent.product._id === rowValue(row)._id">
									{{ rentsObj.key }} ({{ rent.qty }})
								</span>
							</ng-container>
						</ng-container>
					</div>
				</ng-container>
	    </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 100px"> </mat-footer-cell>
		</ng-container>

 		<ng-container matColumnDef="action">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 120px"></mat-header-cell>
	    <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 120px">
        <button mat-button *ngIf="isEditing(row)" [matMenuTriggerFor]="menu" (click)="clickField($event,row,i)" style="padding:0 10px 0 5px !important;"><mat-icon>more_vert</mat-icon><span>SAVE</span></button>
	      <mat-menu #menu="matMenu">
	    	 	<button mat-menu-item type="button" (click)="saveEditedProduct($event,row.formGroup,i,true)" [disabled]="differentStoreSelected" style="margin-left:10px;">ORDERED</button>
	    	 	<button mat-menu-item type="button" (click)="saveEditedProduct($event,row.formGroup,i)" [disabled]="differentStoreSelected" style="margin-left:10px;">SAVE</button>
	    	 	<button
	    	 		mat-menu-item
	    	 		type="button"
	    	 		*ngIf="canReorder(rowValue(row))"
	    	 		(click)="reorderProduct($event,row,i)"
	    	 		[disabled]="differentStoreSelected"
	    	 		style="margin-left:10px;"
	    	 	>{{ reorderLabel(rowValue(row)) }}</button>
	      </mat-menu>
				<button
					mat-button
					type="button"
					*ngIf="!isEditing(row) && canReorder(rowValue(row))"
					(click)="reorderProduct($event,row,i)"
					[disabled]="differentStoreSelected"
					class="reorder-button"
					[attr.title]="reorderLabel(rowValue(row))"
				>REORDER</button>
	    </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 100px"> </mat-footer-cell>
	  </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px"></mat-header-cell>
      <mat-cell *matCellDef="let row; let i=dataIndex;" fxFlex="0 0 50px">
				<mat-icon (click)="deleteProduct($event, row, i)">delete_outline</mat-icon>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="0 0 50px"> </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <mat-cell *matCellDef="let row; let orderIndex=dataIndex;">
        <div class="example-element-detail" style="margin-left:20px;width:100%;padding: 20px 0px 20px 0px;" [class.mat-elevation-z0]="row!=expandedElement" [class.mat-elevation-z8]="row==expandedElement && rowValue(row)._id!='NEW'" [@detailExpand]="row == expandedElement && rowValue(row)._id!='NEW' ? 'expanded' : 'collapsed'" fxLayout="column" fxLayoutAlign="space-around start">

	        <div style="width:1000px; margin-left:205px;" fxFlex *ngIf="row.formGroup" [formGroup]="row.formGroup">
		       	<mat-form-field style="width:100%;">
		          <input #formRow matInput placeholder="NOTES" type="text" [formControl]="row.formGroup.controls.notes" appClickField [(fieldOpen)]="fieldOpen">
		        </mat-form-field>
		      </div>
	        <div style="width:1000px; margin-left:205px;" fxFlex>
		        <app-inventory-history *ngIf="row==expandedElement && rowValue(row)._id!='NEW'" [product]="row.formGroup" [showParts]="showParts" (clickField)="clickField($event,row,orderIndex)" style="width:100%;"></app-inventory-history>
		      </div>
        </div>
      </mat-cell>
    	<!-- <mat-footer-cell *matFooterCellDef> </mat-footer-cell> -->
    </ng-container>

    <mat-header-row
    	*matHeaderRowDef="displayedColumns"
    	fxLayout="row"
    	fxLayoutAlign="none center"></mat-header-row>
    <!-- <mat-row *matRowDef="let row; columns: displayedColumns; let i=dataIndex; let even=even; let odd=odd;" fxLayout="row" fxLayoutAlign="none center" appHighlight [ngClass]="{rowEven:even, rowOdd:odd}"></mat-row> -->
    <mat-row
    	*matRowDef="let row; columns: displayedColumns; let i=dataIndex; let even=even; let odd=odd;"
    	fxLayout="row"
    	fxLayoutAlign="none center"
    	(click)="clickRow($event,row,i)"
    	(dblclick)="clickRow($event,row,i)"
    	[class.dirty-row]="row.formGroup?.dirty"
    	[ngClass]="{rowEven:i%2, rowOdd:(i+1)%2}"
    	[class.return]="rowValue(row).status=='return' && rowValue(row).quantity==0"
    	[class.returned]="rowValue(row).status=='returned' && rowValue(row).quantity==0"
    	color="warn"
    	></mat-row>
    <mat-row *matRowDef="let element; columns: ['expandedDetail']"
      [class.example-detail-row-expanded]="expandedElement === element"
      [class.example-detail-row-collapsed]="expandedElement !== element"
      style="overflow: hidden"
      fxLayoutAlign="start center">
    </mat-row>


    <ng-container *ngIf="authorizedSendToStack">
	  	<mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
	  </ng-container>



  </mat-table>

	<div class="container"
		  fxLayout="row"
		  fxLayoutAlign="start center"
		  fxLayoutGap="10px">
		<div class="item item-1" fxFlex="50%">
		  <button mat-raised-button *ngIf="_vendor && user.role !== 'RENTAL'" type="button" (click)="addProduct($event)" style="margin-left:10px;">+ ADD PRODUCT</button>
		</div>
		<div class="item item-2" fxFlex="50%">
			<mat-paginator #paginator
				[length]="dataSource.data.length"
				[pageSize]="dataSource.data.length">
				<!--[pageSize]="10"
				[pageSizeOptions]="[0,10,20,100]">-->
			</mat-paginator>
		</div>
	</div>
</form>
